"use client";
import PropTypes from "prop-types";

import { combinePageAndResponsePath } from "src/utils/url";

import ProjectRadarShowcase from "src/components/project-radar-landing-page/showcase";
import ProjectRadarHeader from "src/components/project-radar-landing-page/header";
import ProjectRadarContent from "src/components/project-radar-landing-page/content";

const ProjectRadarScreen = ({ pageResponse, filters }) => {
  const { projectCards, searchCriteria } = pageResponse;
  const currentPage = pageResponse?.searchCriteria?.pagination?.page;
  const maximumPage = pageResponse?.maximumPage;
  const baseUrl = combinePageAndResponsePath("/proje-radari", pageResponse?.url);

  return (
    <div>
      <ProjectRadarHeader />
      <ProjectRadarShowcase />
      <ProjectRadarContent
        projectCards={projectCards}
        currentPage={currentPage}
        maximumPage={maximumPage}
        filters={filters}
        searchCriteria={searchCriteria}
        baseUrl={baseUrl}
      />
    </div>
  );
};

ProjectRadarScreen.propTypes = {
  pageResponse: PropTypes.object,
  filters: PropTypes.object,
};

export default ProjectRadarScreen;
